import { moment } from "@msuite/utils/date";
import type {
	IncomingInvoiceEventList,
	IncomingInvoiceEventListItem,
	TimelineSection,
} from "@msuite/utils/types";

/**
 * An invoice's events as the timeline's day sections, newest day first and newest event first
 * within it — the timeline reads from what happened last.
 *
 * @param events - The events, in the order they happened.
 * @returns One section per local day an event fell on.
 */
export function toTimelineSections(
	events: IncomingInvoiceEventList,
): Array<TimelineSection<IncomingInvoiceEventListItem, IncomingInvoiceEventListItem["type"]>> {
	const byDate = new Map<string, IncomingInvoiceEventListItem[]>();
	for (let index = events.length - 1; index >= 0; index--) {
		const event = events[index];
		if (!event) continue;
		const date = moment(event.occurredAt).format("YYYY-MM-DD");
		const day = byDate.get(date) ?? [];
		day.push(event);
		byDate.set(date, day);
	}
	const sections: Array<
		TimelineSection<IncomingInvoiceEventListItem, IncomingInvoiceEventListItem["type"]>
	> = [];
	for (const [date, dayEvents] of byDate) {
		sections.push({ date, items: dayEvents.map((event) => ({ type: event.type, item: event })) });
	}
	return sections;
}
